import { Navigation, Swiper } from "swiper";

export default class ChartSlider {
    static initAll() {
        const swiperContainers = document.querySelectorAll('.chart_slider .swiper-container');
    
        if (swiperContainers.length === 0)
            return;
    
        swiperContainers.forEach((el) => {
            new Swiper(el, {
                grabCursor: false,
                slidesPerView: 1,
                spaceBetween: 50,
                modules: [Navigation],
                navigation: {
                    nextEl: '.slider-button-next',
                    prevEl: '.slider-button-prev'
                },
                on: {
                    transitionStart: function () {
                        let ref = vueApp.$refs['slider_chart_' + this.realIndex];
                        if (ref)
                            ref.destroy();
                    },
                    transitionEnd: function () {
                        let ref = vueApp.$refs['slider_chart_' + this.realIndex];
                        if (ref)
                            ref.init();
                    }
                }
            });
        });
    }
}